module.exports = __webpack_public_path__ + "static/media/apple.b22444c6.svg";